
import { SETTINGS } from '../SETTINGS.js'

class PushManager {
    constructor(){
        this.VAPID_PUBLIC_KEY=SETTINGS.pushNotes.vapidPublicKey;
        this.swregistration = undefined;
        this.subscription = undefined;
    }
    /*
        chrome://settings/content/notifications
        https://vapidkeys.com
    */
    async subscribeUser(){
       
        return new Promise(async (resolve,reject)=>{

           
            if(!navigator.serviceWorker || !window.PushManager || !window.Notification){
                return reject("Web push not supported for this system")
            }

            var _error;

            
            // Notification permission
            let permission = await this._requestPermission();
            
           
            
            //console.log("awaited request permission", permission)

            if (permission!=="granted"){
                return reject("Geen permissie voor pushnotificaties.")
            }
            
            // serviceworker registration, happens at start of app now.
            //var registration = await this._registerServiceWorker().catch(error=>{
                
            //    _error = error;
            //});

            //if(_error){ return reject(_error);}
            
            //alert("this.swregistration="+this.swregistration)
            // check if existing subscription
            var subscription = await this._getExistingPushSubscription(this.swregistration);

            this.subscription = subscription;
            
           
            //let unsubscribe = await this.unsubscribe(subscription);

            if(subscription){
               
                // found, return existing subscription
                return resolve(subscription);
            }

            // create new subscription if not resolved before
            subscription = await this._getNewPushSubscription(this.swregistration).catch(error=>{
                _error = error;
            });

            

            if(_error){ return reject(_error);}
            



            return resolve(subscription);

        })
       
    }

    async _requestPermission(){
        
        if(Notification.permission=="granted"){
            return "granted"
        }

        return await Notification.requestPermission().then(
        (permission) => {
            //console.log("push permission requested...",permission)
            return permission;
        });
 
    }

    //Notification.requestPermission().then( (r)=>{ alert(r) } )
    /*
    navigator.serviceWorker.register("./sw.js").then( (registration)=>{
        registration.pushManager.getSubscription().then((subscription) => { 
            alert(subscription)
        })
     } )
     */
    async _registerServiceWorker(){
       
        
        let sw_js = process.env.NODE_ENV=='development' ? './sw.js?dev-sw' : './sw.js'
        
       
        // return registration value
       
        return navigator.serviceWorker.register(sw_js).then(
            (registration)=>{
                //alert("registered?"+registration.pushManager)
                
                if(!registration.pushManager){
                    return Promise.reject("regsw: De serviceworker kon niet worden geregistreerd")
                }else{
                    console.log('xservice worker registered..')
                    this.swregistration=registration;
                    return Promise.resolve(registration);
                }
            }
        )
           
        
        
        
    }


    // get existing push subscription
    //https://developer.apple.com/library/archive/documentation/NetworkingInternet/Conceptual/NotificationProgrammingGuideForWebsites/PushNotifications/PushNotifications.html
    async _getExistingPushSubscription(registration){
        
        // if registration is undefined then you might need to reload
        // the serviceworker.
        if(!registration){
            console.log("you may need to reload the service worker...")
            return;
        }


        //console.dir("registration",registration)
        if(!registration.pushManager){
            return Promise.reject("registration.Pushmanager is niet beschikbaar op dit systeem")
        }

        
        return await registration.pushManager.getSubscription().then((subscription) => { 
            if (subscription) {
                //console.log("registration.pushManager.getSubscription() [ok]",subscription)
                return subscription;
            }
        }).catch((error)=>{
            console.log("registration.pushManager.getSubscription() [error]",error)
        })
        
        
        
    }   

    async _getNewPushSubscription(registration){
        
        return await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: this._urlBase64ToUint8Array(this.VAPID_PUBLIC_KEY),
            }).then((subscription) => {
                console.log("NEW SUBSCRIPTION",subscription)
                return subscription;
            })
    }

    async _unsubscribe(subscription){
        return await subscription.unsubscribe().then(() => {
            return "ok";
        })
    }

    
       _urlBase64ToUint8Array(base64String) {
            var padding = '='.repeat((4 - base64String.length % 4) % 4);
            var base64 = (base64String + padding)
                .replace(/-/g, '+')
                .replace(/_/g, '/');
        
            var rawData = window.atob(base64);
            var outputArray = new Uint8Array(rawData.length);
        
            for (var i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        }
}

// export as module i guess
export default new PushManager()